import React, { useEffect, useState } from 'react';
import { Box, TableCell, TableRow, Typography } from '@mui/material';

// COMPONENTS
import CardWrapper from '../../CardWrapper';
import Loader from '../../../common/Loader';
import DashboardTable from '../../DashboardTable';

// MESSAGES
import HomeFormattedMessages from '../../../../messages/HomeFormattedMessages';

// REQUESTS
import useDashboardRequest from '../../../../requests/DashboardRequest';

export default function Campaigns({ errorHandler }) {
  const [campaignData, setCampaignData] = useState([]);
  const [loading, setLoading] = useState(true);
  const { getCustomerCampaigns } = useDashboardRequest();

  const columns = [
    { id: 'campaignno', label: 'Campaign No.' },
    { id: 'campaigntype', label: 'Campaign Type' },
    { id: 'numbers', label: 'Numbers' },
  ];

  const loadData = async () => {
    const response = await getCustomerCampaigns(errorHandler);
    setCampaignData(response);
    setLoading(false);
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <CardWrapper title={HomeFormattedMessages.tenDlcCampaigns} icon="campaign">
      {loading ? (
        <Loader />
      ) : campaignData.length === 0 ? (
        <Box sx={{ marginTop: 2 }}>
          <Typography>{HomeFormattedMessages.noDataAvailable}</Typography>
        </Box>
      ) : (
        <Box>
          <DashboardTable columns={columns}>
            {campaignData.map((item, index) => (
              <TableRow key={`row_${index}`}>
                <TableCell>{item.campaign_code}</TableCell>
                <TableCell>{item.use_case}</TableCell>
                <TableCell>{item['Dedicated Number']}</TableCell>
              </TableRow>
            ))}
          </DashboardTable>
        </Box>
      )}
    </CardWrapper>
  );
}
